import { render, staticRenderFns } from "./PaymentAdditionalList.vue?vue&type=template&id=39104518&scoped=true"
import script from "./PaymentAdditionalList.vue?vue&type=script&lang=js"
export * from "./PaymentAdditionalList.vue?vue&type=script&lang=js"
import style0 from "./PaymentAdditionalList.vue?vue&type=style&index=0&id=39104518&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39104518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39104518')) {
      api.createRecord('39104518', component.options)
    } else {
      api.reload('39104518', component.options)
    }
    module.hot.accept("./PaymentAdditionalList.vue?vue&type=template&id=39104518&scoped=true", function () {
      api.rerender('39104518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/tabs/PaymentAdditionalList.vue"
export default component.exports